(($, Drupal) => {
  "use strict";

  Drupal.behaviors.questionModalQuizMobileHeader = {
    originalTexts: null, // To store original button texts
    attach(context) {
      if ($(window).width() < 992) {
        const $carouselButtons = $(
          ".carousel-indicators .carousel-indicators__indicator",
          context
        );

        // Ensure buttons exist before proceeding
        if ($carouselButtons.length > 0) {
          // Initialize originalTexts if not already set
          if (!this.originalTexts) {
            const $carouselButtonsTextWrappers = $(
              ".carousel-indicators .carousel-indicators__indicator span",
              context
            );
            this.originalTexts = $carouselButtonsTextWrappers
              .map((_, span) => span.textContent)
              .get();
          }

          // Update button text to numbers or original text based on active state
          const updateButtonTexts = (activeIndex) => {
            $carouselButtons.each((index, button) => {
              const $button = $(button);
              const $textWrapper = $button.find("span");
              const isActive = index === activeIndex;

              $textWrapper.text(
                isActive ? this.originalTexts[index] : index + 1
              );
              $button.toggleClass("active", isActive);
            });
          };

          // Detect active tab on load and update texts
          const initialActiveIndex = $carouselButtons.index(
            $carouselButtons.filter(".active")
          );
          updateButtonTexts(initialActiveIndex);

          // Detect tab change and update texts dynamically
          $carouselButtons.on("click", function () {
            const clickedIndex = $carouselButtons.index($(this));
            updateButtonTexts(clickedIndex);
          });
        }
      }
    },
  };
})(jQuery, Drupal);
